// extracted by mini-css-extract-plugin
export default {"corsecont":"Course_corsecont__AIySS"};